var map = {
	"./clear1.png": 9972,
	"./clear2.png": 8783,
	"./clear3.png": 3686,
	"./clear3noHp.png": 4559,
	"./iconATK.png": 2145,
	"./iconDEF.png": 7690,
	"./iconEXPMULTI.png": 5687,
	"./iconHP.png": 2199,
	"./iconHPMULTI.png": 9016,
	"./iconLVL.png": 7029,
	"./iconMaxHP.png": 5053,
	"./lastInflator.png": 8043,
	"./medalBronze.png": 8555,
	"./medalDiamond.png": 231,
	"./medalGold.png": 1945,
	"./medalMoon.png": 2056,
	"./medalPlatinum.png": 7755,
	"./medalSilver.png": 3696,
	"./medalSun.png": 4521,
	"./mysticgate.png": 4358,
	"./sunstone.png": 2181,
	"./sunwisher.png": 8600
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 569;